import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import MenuButton from './MenuButton';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import BiotechRoundedIcon from '@mui/icons-material/BiotechRounded';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import MenuBookRoundedIcon from '@mui/icons-material/MenuBookRounded';
import BarChartIcon from '@mui/icons-material/BarChart';
import MovingRoundedIcon from '@mui/icons-material/MovingRounded';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import AutoStoriesIcon from '@mui/icons-material/AutoStories';
import AddBoxIcon from '@mui/icons-material/AddBox';
import classNames from 'classnames';


const NavigationLinks = ({ handleClick, isActive, stimsUrl, currentUrl }) => {
  const userType = parseInt(localStorage.getItem('userType'));
  const dashboard = userType === 1 ? 'my_studies' : 'my_batches';
  const dashboardText = userType === 1 ? 'My Studies' : 'My Batches';

  return (

    <div className='lu-aside__navigation' >
      {/* main sidebar */}
      <div style={{position: 'fixed', 
        display: 'flex', 
        justifyContent: 'flex-end', 
        top:0, height:64, 
        clipPath: 'inset(0px 0px -15px 0px)', 
        background: '#00badb', 
        width:'100%', 
        boxShadow: 'rgb(0 0 0 / 20%) 0px 2px 4px -1px, rgb(0 0 0 / 14%) 0px 4px 5px 0px, rgb(0 0 0 / 12%) 0px 1px 10px 0px'}} 
        className='lu-aside__control'
        >

        <MenuButton 
        accessibleText='Toggle Menu' 
        className='lu-aside__toggle-menu' 
        handleClick={handleClick} 
        isActive={isActive} 
        />
      </div>

      <ul 
      style={{ 
        background:'white', 
        borderRight: '1px solid rgba(0, 0, 0, 0.12)'}} 
        className='lu-aside__menu'
        >

        {(currentUrl === '/') && 
        <li 
        className='lu-aside__menu-item lu-aside__menu-active'
        >
          <Link 
          style={{color:'white'}} 
          to='/' 
          className='lu-aside__menu-anchor'>
            Home
          </Link>

          <Link 
          to='/' 
          className='lu-aside__menu-image'
          >
            <HomeOutlinedIcon 
            style={{color: 'white'}} 
            /> 
          </Link>
          </li>
          }


        {(currentUrl !== '/')
         && 
         <li 
         className='lu-aside__menu-item'
         >
          <Link 
          to='/' 
          className='lu-aside__menu-anchor'
          >
            Home
          </Link>

          <Link 
          to='/' 
          className='lu-aside__menu-image'
          >
            <HomeOutlinedIcon 
            style={{color: 'inherit'}} 
            />
            </Link>
            </li>
            }


        {(currentUrl.includes(`/${dashboard}`))
          ? <li 
          className='lu-aside__menu-item lu-aside__menu-active'
          >
            <Link style={{color:'white'}}
            to={`/${dashboard}`} 
            className='lu-aside__menu-anchor'
            >
              {dashboardText}
              </Link>
              
              <Link 
              to={`/${dashboard}`} 
              className='lu-aside__menu-image'>
                <BiotechRoundedIcon 
                style={{color: 'white'}} />
                </Link>
                </li> : 
                <li 
                className='lu-aside__menu-item'>
                  <Link 
                  to={`/${dashboard}`} 
                  className='lu-aside__menu-anchor'>
                    {dashboardText}
                    </Link>
                    
                    <Link 
                    to={`/${dashboard}`} 
                    className='lu-aside__menu-image'>
                      <BiotechRoundedIcon 
                      style={{color: 'inherit'}} />
                      </Link>
                      </li>
                      }

        {(currentUrl.includes('stim'))
          ? <li 
          className='lu-aside__menu-item lu-aside__menu-active'>
            <Link 
            style={{color:'white'}} 
            to={stimsUrl} 
            className='lu-aside__menu-anchor '>
              My Stimuli
              </Link>
              
              <Link 
              to={stimsUrl} 
              className='lu-aside__menu-image'>
                 <VisibilityOutlinedIcon 
                 style={{color: 'white'}} />
                 </Link>
                 </li>
          : <li 
          className='lu-aside__menu-item'>
            <Link 
            to={stimsUrl} 
            className='lu-aside__menu-anchor '>
              My Stimuli
              </Link>

              <Link 
              to={stimsUrl} 
              className='lu-aside__menu-image'>
                <VisibilityOutlinedIcon 
                style={{color: 'inherit'}} />
                </Link>
                </li>}


        

{/* cache pages */}
{/* Cache Pages */}
{currentUrl.includes("/my_cache_pages") ? (
  <li className="lu-aside__menu-item lu-aside__menu-active">
    <Link style={{ color: "white" }} to="/my_cache_pages" className="lu-aside__menu-anchor">
      My Cache Pages
    </Link>
    <Link to="/my_cache_pages" className="lu-aside__menu-image">
      <AutoStoriesIcon style={{ color: "white" }} />
    </Link>
  </li>
) : (
  <li className="lu-aside__menu-item">
    <Link to="/my_cache_pages" className="lu-aside__menu-anchor">
      My Cache Pages
    </Link>
    <Link to="/my_cache_pages" className="lu-aside__menu-image">
      <AutoStoriesIcon style={{ color: "inherit" }} />
    </Link>
  </li>
)}

        {(currentUrl === '/my_downloads') && 
        <li 
        className='lu-aside__menu-item lu-aside__menu-active'>

          <Link 
          style={{color:'white'}} 
          to='/my_downloads' 
          className='lu-aside__menu-anchor'>
            My Downloads
            </Link>

            <Link 
            to='/my_downloads' 
            className='lu-aside__menu-image'>
              <MenuBookRoundedIcon 
              style={{color: 'white'}} />
              </Link>
              </li>
              }

        {(currentUrl !== '/my_downloads') &&
         <li 
         className='lu-aside__menu-item'>
          <Link 
          to='/my_downloads' 
          className='lu-aside__menu-anchor'>
            My Downloads
            </Link>
            
            <Link 
            to='/my_downloads'
            className='lu-aside__menu-image'>
              <MenuBookRoundedIcon 
              style={{color: 'inherit'}} />
              </Link>
              </li>
              }
        
        <li 
        className={classNames('lu-aside__menu-item', { 'lu-aside__menu-active' : currentUrl.includes('/my_reports') })}>

          <Link
            to='/my_reports'
            style={{color: currentUrl.includes('/my_reports') ? 'white' : 'inherit'}}
            className={ classNames('lu-aside__menu-anchor')}
          >
            My Reports
            <div className='lu-aside__menu-image'>
              <BarChartIcon style={{color: currentUrl === '/my_reports' ? 'white' : 'inherit'}}/>
            </div>
          </Link>
        </li>
        
        {/* Admin tab */}
          <li className={classNames('lu-aside__menu-item', { 
            'lu-aside__menu-active': currentUrl.includes('/admin')
            })}
          >
          <Link to='/admin' style={{ color: currentUrl.includes('/admin') ? 'white' : 'inherit'}}
            className='lu-aside__menu-anchor' >
            Admin
            <div className='lu-aside__menu-image'>
              <AdminPanelSettingsIcon
                style={{color: currentUrl.includes('/admin') ? 'white' : 'inherit'}} />
            </div>
        </Link>
        </li>
        {/* /* Admin sub tab right panel - only shown when admin tab is active*/ }
      {currentUrl === '/admin' && userType !== 2 && (
          <div style={{ width: '220px', borderRight: '1px solid rgba(0,0,0,0.12)', background: '#fafafa', left: '15.7rem', position: 'relative', bottom: '4rem'
          }} >
            <ul className='lu-aside__menu' style={{padding: '0', height: 'fit-content', background: '#fafafa'}}>
              <li className={classNames('lu-aside__menu-item', { 'lu-aside__menu-active' : currentUrl.includes('/admin/my_validations') 
          })}
        >
          <Link
            to='/admin/my_validations'
            style={{color: currentUrl.includes('/admin/my_validations') ? 'white' : 'inherit'}}
            className='lu-aside__menu-anchor'
          >
            My Validations
            <div className='lu-aside__menu-image'>
              <MovingRoundedIcon style={{color: currentUrl.includes('/admin/my_validations') ? 'white' : 'inherit'}}
            />
          </div>
        </Link>
      </li>
    <li className={classNames('lu-aside__menu-item', { 'lu-aside__menu-active' : currentUrl.includes('/admin/my_look_up_tables') })}>
          <Link
            to='/admin/my_look_up_tables'
            style={{color: currentUrl.includes('/admin/my_look_up_tables') ? 'white' : 'inherit'}}
            className={ classNames('lu-aside__menu-anchor')}
          >
            My Look Up Tables
            <div className='lu-aside__menu-image'>
              <AddBoxIcon style={{color: currentUrl === '/admin/my_look_up_tables' ? 'white' : 'inherit'}}/>
            </div>
          </Link>
        </li>
    </ul>
    </div>
      )}
      </ul>
    

      
      </div>
    )};


NavigationLinks.propTypes = {
  handleClick: PropTypes.func,
  onFilterClick: PropTypes.func,
  currentUrl: PropTypes.string,
  stimsUrl: PropTypes.string,
  isActive: PropTypes.bool,
};

export default NavigationLinks;
